<form #addForm="ngForm" class="form-v2" (submit)="ok()" novalidate>
    <div class="modal-header">
        <div class="modal-header-left">
            <h4 class="modal-title">
                <span *ngIf="!quoteRequest.RequestNumber">New</span> Quote Request
                <span *ngIf="quoteRequest.RequestNumber">{{ quoteRequest.RequestNumber }}</span>
            </h4>
        </div>
        <div class="modal-header-right swMain">
            <!-- start: WIZARD STEP CRUMB TRAIL -->
            <ul class="wizard-small">
                <li>
                    <a [ngClass]="{ selected: currentStep == 1, done: currentStep > 1 }">
                        <div class="stepNumber">1</div>
                        <span class="stepDesc text-small"> Set up </span>
                    </a>
                </li>
                <li>
                    <a [ngClass]="{ selected: currentStep == 2, done: currentStep > 2 }">
                        <div class="stepNumber">2</div>
                        <span class="stepDesc text-small"> Scope of Work </span>
                    </a>
                </li>
                <li>
                    <a [ngClass]="{ selected: currentStep == 3, done: currentStep > 3 }">
                        <div class="stepNumber">3</div>
                        <span class="stepDesc text-small"> Recipients </span>
                    </a>
                </li>
            </ul>
            <!-- end: WIZARD STEP CRUMB TRAIL -->
        </div>
    </div>
    <div class="modal-body">
        <div id="wizard" class="swMain">
            <!-- start: WIZARD STEP 1 -->
            <div id="step-1" *ngIf="currentStep === 1">
                <div class="form-group">
                    <label class="text-info"><span class="mandatory-field"></span>Title</label>
                    <input
                        legacy-css
                        name="title"
                        type="text"
                        class="form-control"
                        [(ngModel)]="quoteRequest.Title"
                        maxlength="{{ titleMaxLength }}"
                        placeholder="Enter a title for this Quote Request"
                        required
                        autofocus />
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group date-picker-hide-clear">
                            <label class="text-info"
                                ><span class="mandatory-field"></span> Deadline Date <br /><em
                                    >Default is two weeks from today. Reminders will be emailed to on deadline date to
                                    suppliers/tradespersons that have not submitted their quote.</em
                                >
                            </label>
                            <input
                                legacy-css
                                name="deadline"
                                type="text"
                                placeholder="Deadline Date"
                                class="form-control form-control-v2"
                                [(ngModel)]="dt"
                                [minDate]="quoteRequest.Status === 'Closed' ? dt : today"
                                (bsValueChange)="dateDeadlineFormat($event, quoteRequest)"
                                required="true"
                                bsDatepicker
                                [bsConfig]="{
                                    adaptivePosition: true,
                                    showWeekNumbers: false,
                                    containerClass: 'theme-default',
                                }" />
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="text-info" *ngIf="quoteRequest.QuoteRequestItems?.length || isBlankRFQ"> Items </label>

                    <div class="checkbox" *ngIf="hasRecipes">
                        <input
                            legacy-css
                            [disabled]="!!quoteRequest.DateReleased"
                            name="includeRecipeQuantity"
                            type="checkbox"
                            id="includeRecipeQuantity"
                            [(ngModel)]="quoteRequest.IncludeRecipeQuantity" />
                        <label class="padding-left-0" for="includeRecipeQuantity">
                            Include {{ 'general.recipe' | translate | lowercase }} quantities
                        </label>
                    </div>

                    <section class="quote-request-span-tbl quote-request-span-tbl--items">
                        <p class="info" *ngIf="!quoteRequest.QuoteRequestItems?.length && !isBlankRFQ">
                            Please<a href="" (click)="cancel()">&nbsp;cancel&nbsp;</a>and select at least one estimate / costing item.
                        </p>

                        <table
                            class="table table-white"
                            style="table-layout: fixed"
                            *ngIf="quoteRequest.QuoteRequestItems?.length || isBlankRFQ">
                            <colgroup>
                                <col width="50%" />
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                                <col width="92px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th>Qty</th>
                                    <th>UOM</th>
                                    <th>Type</th>
                                    <th><!-- Item Options --></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let entry of itemsAndGroups; let i = index" [ngClass]="{ 'gray-bg': !entry.isItem }">
                                    <td [class.condensed-col]="entry.isItem && isBlankRFQ">
                                        <span
                                            [ngClass]="{ 'margin-left-20': entry.isRecipeItem }"
                                            *ngIf="entry.isItem && (!isBlankRFQ || quoteRequest.DateReleased)"
                                            >{{ entry.Description }}</span
                                        >
                                        <span *ngIf="!entry.isItem"
                                            ><b>{{ entry.Description }}</b></span
                                        >
                                        <input
                                            legacy-css
                                            *ngIf="entry.isItem && isBlankRFQ && !quoteRequest.DateReleased"
                                            type="text"
                                            class="form-control"
                                            [(ngModel)]="entry.Description"
                                            maxlength="255"
                                            name="description_{{ i }}"
                                            placeholder="New Item"
                                            editable-form-focus
                                            appSelectAllOnFocus
                                            appSelectAllOnFocusFilter="New Item"
                                            appNullReplace="Item Description" />
                                    </td>
                                    <td class="condensed-col text-right min-width-100 width-100" style="width: 25%">
                                        <div
                                            *ngIf="entry.isItem"
                                            class="input-group input-group-sm"
                                            [class.float-right]="entry.isRecipeItem">
                                            <span
                                                class="item-padding"
                                                *ngIf="(entry.ID_JobItem && !entry.AllowQtyEdit) || entry.isRecipeItem; else qtyInput">
                                                {{ entry.isRecipeItem && entry.UOMUnits ? entry.UOMUnits : entry.Quantity }}</span
                                            >
                                            <ng-template #qtyInput>
                                                <input
                                                    legacy-css
                                                    name="quantity_{{ i }}"
                                                    type="text"
                                                    class="form-control text-right"
                                                    [(ngModel)]="entry.Quantity"
                                                    (change)="updatedQuantity(entry)"
                                                    [max]="99999999999999999999999"
                                                    [min]="0"
                                                    [decimals]="3"
                                                    appNumeric
                                                    appSelectAllOnFocus
                                                    appNullReplace="0" />
                                            </ng-template>
                                        </div>
                                    </td>
                                    <td class="condensed-col">
                                        <span class="item-padding" *ngIf="entry.isItem && (!isBlankRFQ || quoteRequest.DateReleased)">{{
                                            entry.UOM
                                        }}</span>
                                        <input
                                            legacy-css
                                            *ngIf="entry.isItem && isBlankRFQ && !quoteRequest.DateReleased"
                                            type="text"
                                            maxlength="50"
                                            [(ngModel)]="entry.UOM"
                                            name="uom_{{ i }}"
                                            [typeahead]="unitMeasures"
                                            class="form-control"
                                            [typeaheadMinLength]="1"
                                            container="body" />
                                    </td>
                                    <td class="condensed-col">
                                        <span class="item-padding" *ngIf="entry.isItem && (!isBlankRFQ || quoteRequest.DateReleased)">{{
                                            entry.DisplayedCostItemType
                                        }}</span>
                                        <select
                                            legacy-css
                                            name="type_{{ i }}"
                                            class="form-control"
                                            [(ngModel)]="entry.CostItemType"
                                            [ngModelOptions]="{ standalone: true }"
                                            (change)="setTaxRates(entry)"
                                            *ngIf="entry.isItem && isBlankRFQ && !quoteRequest.DateReleased">
                                            <option *ngFor="let c of this.taxService?.allCostItemTypePairs()" [ngValue]="c.cit">
                                                {{ c.display }}
                                            </option>
                                        </select>
                                    </td>
                                    <td class="center">
                                        <button
                                            *ngIf="entry.isItem"
                                            id="remove_item_{{ i }}"
                                            type="button"
                                            class="btn btn-danger btn-sm"
                                            title="Click to remove this selected Cost item"
                                            [disabled]="quoteRequest.DateReleased"
                                            (click)="removeSelectedItem(entry)"
                                            uib-tooltip="Remove from selection"
                                            tooltip-append-to-body="true">
                                            <i class="ti-trash"></i>
                                        </button>

                                        <ng-container *ngIf="!entry.isItem">
                                            <button
                                                type="button"
                                                id="remove_category_{{ i }}"
                                                class="btn btn-danger btn-sm"
                                                title="Click to remove this selected Cost item"
                                                [disabled]="quoteRequest.DateReleased"
                                                (click)="removeSelectedItem(entry)"
                                                *ngIf="!isBlankRFQ; else addItems"
                                                uib-tooltip="Remove from selection"
                                                tooltip-append-to-body="true">
                                                <i class="ti-trash"></i>
                                            </button>
                                        </ng-container>

                                        <ng-template #addItems>
                                            <button
                                                id="addNewCategoryItems_{{ i }}"
                                                type="button"
                                                class="btn btn-success btn-sm"
                                                [disabled]="quoteRequest.DateReleased"
                                                (click)="addNewItems()"
                                                title="Add Items"
                                                container="body">
                                                <i class="ti-plus"></i>
                                            </button>
                                        </ng-template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="alert alert-danger clearfix" *ngIf="itemsWithZeroQty && quoteRequest.QuoteRequestItems?.length">
                            All items must have a quantity greater than <strong>0</strong> before you can proceed.
                        </div>
                    </section>
                </div>
            </div>
            <!-- end: WIZARD STEP 1 -->

            <!-- start: WIZARD STEP 2 -->
            <div id="step-2" *ngIf="currentStep === 2">
                <div class="form-group">
                    <div class="row" style="margin: 5px 0">
                        <div class="col-md-12" *ngIf="docs.length || plans.length || estimateMeasurements.length">
                            <label class="text-info"
                                >Include files from this <span *ngIf="quoteRequest.ID_Job; then job; else estimate"></span>
                                <ng-template #estimate><span>Estimate</span></ng-template>
                                <ng-template #job
                                    ><span>Job<span *ngIf="quoteRequest.ID_Estimate; then jobNestimate"></span> </span
                                ></ng-template>
                                <ng-template #jobNestimate><span> & Estimate</span></ng-template>
                            </label>
                            <ul class="nav nav-pills nav-pills--inline">
                                <li *ngIf="docs.length" [ngClass]="{ active: fileMode === 2 }">
                                    <a (click)="setFileMode(2)"
                                        >Select Documents
                                        <span *ngIf="selectedEstimateDocuments.length > 0"
                                            ><strong>{{ selectedEstimateDocuments.length }}</strong></span
                                        ></a
                                    >
                                </li>
                                <li *ngIf="plans.length" [ngClass]="{ active: fileMode === 3 }">
                                    <a (click)="setFileMode(3)"
                                        >Select Plans
                                        <span *ngIf="selectedEstimatePlans.length > 0"
                                            ><strong>{{ selectedEstimatePlans.length }}</strong></span
                                        ></a
                                    >
                                </li>
                                <li *ngIf="estimateMeasurements.length" [ngClass]="{ active: fileMode === 4 }">
                                    <a (click)="setFileMode(4)"
                                        >Select Takeoffs
                                        <span *ngIf="selectedEstimateMeasurements.length > 0"
                                            ><strong>{{ selectedEstimateMeasurements.length }}</strong></span
                                        ></a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div *ngIf="fileMode === 2" class="panel-body panel-body--compact">
                        <table class="table table--headings" *ngIf="docs.length">
                            <thead>
                                <tr>
                                    <th width="12%">
                                        <div class="margin-0 checkbox check-primary">
                                            <input
                                                legacy-css
                                                name="selectAllDocuments"
                                                type="checkbox"
                                                id="selectAllDocuments"
                                                [ngModel]="isAllDocumentsSelected"
                                                (change)="toggleAllDocumentsSelection($event)" />
                                            <label class="checkBoxLabel" for="selectAllDocuments"></label>
                                        </div>
                                    </th>
                                    <th>Document name</th>
                                </tr>
                            </thead>
                        </table>
                        <section class="quote-request-add-listings__list">
                            <table class="table" *ngIf="docs.length">
                                <tbody>
                                    <tr *ngFor="let doc of docs; let $index = index">
                                        <td width="12%">
                                            <!--{{selectedEstimateDocuments}}-->
                                            <div class="margin-0 checkbox check-primary">
                                                <input
                                                    legacy-css
                                                    name="doc_{{ $index }}_check"
                                                    type="checkbox"
                                                    id="doc_{{ $index }}_check"
                                                    [(ngModel)]="doc.selected"
                                                    (change)="toggleDocSelection(doc)" />
                                                <label class="checkBoxLabel" for="doc_{{ $index }}_check"> </label>
                                            </div>
                                        </td>
                                        <td>
                                            <a href="{{ doc.storageUrl }}" target="_blank"
                                                ><span *ngIf="!folderCheckGuid(doc.folder)"
                                                    ><i class="ti-folder"></i
                                                    ><strong>&nbsp;{{ doc.folder }} <i class="ti-angle-right"></i></strong
                                                ></span>
                                                {{ doc.fileName }}</a
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <p class="quote-request-footer-count">
                            {{ selectedEstimateDocuments.length }} selected Document<span *ngIf="selectedEstimateDocuments.length !== 1"
                                >s</span
                            >
                        </p>
                    </div>

                    <div *ngIf="fileMode === 3" class="panel-body panel-body--compact">
                        <table class="table table--headings" *ngIf="plans.length">
                            <thead>
                                <tr>
                                    <th width="12%">
                                        <div class="margin-0 checkbox check-primary">
                                            <input
                                                legacy-css
                                                name="selectAllPlans"
                                                type="checkbox"
                                                id="selectAllPlans"
                                                [ngModel]="isAllPlansSelected"
                                                (change)="toggleAllPlanSelection($event)" />
                                            <label class="checkBoxLabel" for="selectAllPlans"></label>
                                        </div>
                                    </th>
                                    <th>Plan name</th>
                                </tr>
                            </thead>
                        </table>
                        <section class="quote-request-add-listings__list">
                            <table class="table" *ngIf="plans.length">
                                <tbody>
                                    <tr *ngFor="let plan of plans; let $index = index">
                                        <td width="12%">
                                            <div class="margin-0 checkbox check-primary">
                                                <input
                                                    legacy-css
                                                    name="plan_{{ $index }}_check"
                                                    type="checkbox"
                                                    id="plan_{{ $index }}_check"
                                                    [(ngModel)]="plan.selected"
                                                    (change)="togglePlanSelection(plan)" />
                                                <label class="checkBoxLabel" for="plan_{{ $index }}_check"> </label>
                                            </div>
                                        </td>
                                        <td><i class="ti-image"></i>&nbsp;&nbsp;{{ plan.PlanLabel }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <p class="quote-request-footer-count">
                            {{ selectedEstimatePlans.length }} selected Plan<span *ngIf="selectedEstimatePlans.length !== 1">s</span>
                        </p>
                    </div>

                    <div *ngIf="fileMode === 4" class="panel-body panel-body--compact">
                        <table class="table table--headings" *ngIf="plans.length">
                            <thead>
                                <tr>
                                    <th width="12%">
                                        <div class="margin-0 checkbox check-primary">
                                            <input
                                                legacy-css
                                                name="selectAllMeasurement"
                                                type="checkbox"
                                                id="selectAllMeasurement"
                                                [ngModel]="isAllMeasurementSelected"
                                                (change)="toggleAllMeasurementSelection($event)" />
                                            <label class="checkBoxLabel" for="selectAllMeasurement"></label>
                                        </div>
                                    </th>
                                    <th>Takeoff Description</th>
                                    <th width="20%">Measurement</th>
                                    <th width="20%">UOM</th>
                                </tr>
                            </thead>
                        </table>
                        <section class="quote-request-add-listings__list">
                            <table class="table" *ngIf="estimateMeasurements.length">
                                <tbody>
                                    <tr *ngFor="let estimateMeasurement of estimateMeasurements; let $index = index">
                                        <td width="12%">
                                            <div class="margin-0 checkbox check-primary">
                                                <input
                                                    legacy-css
                                                    name="estimateMeasurement_{{ $index }}_check"
                                                    type="checkbox"
                                                    id="estimateMeasurement_{{ $index }}_check"
                                                    [(ngModel)]="estimateMeasurement.selected"
                                                    (change)="toggleEstimateMeasurementSelection(estimateMeasurement)" />
                                                <label class="checkBoxLabel" for="estimateMeasurement_{{ $index }}_check"> </label>
                                            </div>
                                        </td>
                                        <td>{{ estimateMeasurement.Description }}</td>
                                        <td width="20%">{{ estimateMeasurement.Measurement }}</td>
                                        <td width="20%">{{ estimateMeasurement.UOM }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <table>
                            <tr>
                                <td class="checkbox check-primary">
                                    <input legacy-css type="checkbox" name="showLabels" id="showLabels" [(ngModel)]="showTakeOffLabels" />
                                    <label for="showLabels"> Show labels for each takeoff drawing </label>
                                </td>
                                <td style="text-align: right">
                                    {{ selectedEstimateMeasurements.length }} selected Takeoff<span
                                        *ngIf="selectedEstimateMeasurements.length !== 1"
                                        >s</span
                                    >
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row" style="margin: 5px 0">
                        <div class="col-md-12">
                            <label class="text-info">Upload new files</label>
                            <ul class="nav nav-pills nav-pills--inline">
                                <li [ngClass]="{ active: fileMode === 1 }">
                                    <a (click)="setFileMode(1)"
                                        >Add Attachments
                                        <span *ngIf="attachments.length > 0"
                                            ><strong>{{ attachments.length }}</strong></span
                                        ></a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div *ngIf="fileMode === 1" class="panel-body panel-body--compact">
                        <!-- <div class="margin-top-10" documents="documentsParams"></div> -->
                        <app-bx-documents
                            (uploadEvent)="uploadCallback()"
                            (deleteEvent)="deleteCallback()"
                            [hideTrashIcon]="documentsParams.hideTrashIcon"
                            [includeFolders]="documentsParams.includeFolders"
                            [reference]="documentsParams.reference"
                            [sourceType]="documentsParams.sourceType"
                            [hideAddButton]="quoteRequest.Status === 'Closed'">
                        </app-bx-documents>
                    </div>
                </div>
                <div class="form-group">
                    <div class="panel panel-white">
                        <div class="panel-heading panel-heading--compact _border-light">
                            <h4 class="panel-title">Scope of Work</h4>
                            <label class="text-info">
                                <span>Please describe the required work in detail.</span>
                            </label>
                            <ul class="panel-heading-tabs border-light">
                                <li>
                                    <div class="btn-group dropdown" dropdown [isDisabled]="quoteRequest.Status === 'Closed'">
                                        <button
                                            type="button"
                                            id="presets-dropdown-step-2"
                                            class="btn btn-default dropdown-toggle"
                                            dropdownToggle=""
                                            aria-haspopup="true"
                                            aria-expanded="false">
                                            <i class="ti-settings"></i> <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-right no-max-height" role="menu">
                                            <li>
                                                <a (click)="savePresetModal()"><i class="ti-save"></i> Save as preset</a>
                                            </li>
                                            <li>
                                                <a (click)="showManagePresetsModal()"><i class="ti-pencil"></i> Manage presets</a>
                                            </li>
                                            <li class="divider"></li>
                                            <ng-container *ngIf="!estimate?.IsReadOnly">
                                                <li disabled>
                                                    <span class="margin-left-20">Apply Preset</span>
                                                </li>
                                                <li *ngFor="let preset of getCurrentPresets()">
                                                    <a (click)="applyPreset(preset)"><i class="ti-list"></i> {{ preset.Description }}</a>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="panel-body">
                            <bx-editor
                                class="bx-editor__height-200"
                                [(data)]="quoteRequest.ScopeDescription"
                                [config]="editorOptions"
                                placeholder="Enter a description of the scope of work to be carried out."
                                required></bx-editor>
                        </div>
                    </div>
                    <!--<div ng-bind-html="quoteRequest.ScopeDescription"></div>-->
                </div>
            </div>
            <!-- end: WIZARD STEP 2 -->

            <!-- start: WIZARD STEP 3 -->
            <div id="step-3" *ngIf="currentStep === 3">
                <h5 *ngIf="previousRecipients.length">Previously Selected Recipients</h5>
                <div *ngIf="previousRecipients.length" class="previous-recipients-wrapper">
                    <button
                        class="label label-default"
                        style="display: inline-block"
                        *ngFor="let previousRecipient of previousRecipients"
                        [disabled]="previousRecipient.notified !== false"
                        (click)="removePreviousRecipient(previousRecipient.email)">
                        {{ previousRecipient.email }}<span *ngIf="!previousRecipient.notified">&times;</span>
                    </button>
                </div>
                <h5>Add Recipients</h5>
                <p *ngIf="contactsMissingEmails > 0">
                    There are {{ contactsMissingEmails }} Contacts without email addresses not available here. To save your Quote Request
                    and view the list of Contacts
                    <a (click)="saveDraft()" [routerLink]="['/contacts', 'list']" [queryParams]="{ group: '', status: 'noemail' }"
                        >click here</a
                    >.
                </p>
                <div class="form-group">
                    <app-ui-contact-selector
                        #contactSelector
                        [data]="contacts"
                        placeholder="To..."
                        [ngModel]="newRecipients"
                        (ngModelChange)="newRecipients = $event"
                        name="newRecipients"
                        [type]="contactType.Email"
                        [required]="true"
                        (onItemAdded)="contactAdded($event)"
                        (onItemRemoved)="contactRemoved($event)">
                    </app-ui-contact-selector>
                </div>

                <div class="form-group" *ngIf="accounts.length">
                    <label class="text-info"> From </label>

                    <ng-select
                        class="light"
                        name="emailFrom"
                        [items]="accounts"
                        #emailFrom="ngModel"
                        [clearable]="false"
                        [searchable]="false"
                        labelForId="accountId"
                        placeholder="Select a sender to send from..."
                        bindValue="accountId"
                        bindLabel="emailAddress"
                        [(ngModel)]="config.from">
                        <ng-template ng-label-tmp let-item="item">
                            {{ item.emailAddress || item.fromName }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            <span>{{ item.emailAddress || item.fromName }}</span>
                            <small *ngIf="item.status !== 'running'">
                                <span
                                    class="margin-left-10 label text-capitalize"
                                    [ngClass]="{
                                        'label-info': item.status === 'initializing',
                                        'label-success': item.status === 'downloading' || item.status === 'running',
                                        'label-warning': item.status === 'invalid-credentials',
                                        'label-danger':
                                            item.status === 'stopped' || item.status === 'exception' || item.status === 'sync-error',
                                    }"
                                    >{{ item.status }}</span
                                >
                            </small>
                        </ng-template>
                    </ng-select>
                </div>

                <div class="form-group text-center" style="border-bottom: 1px solid #ababab; padding-bottom: 10px">
                    <a class="btn btn-xs btn-success" (click)="addContact()"><i class="ti-plus"></i> Add a new contact</a>
                </div>

                <div class="form-group recipient-connections" *ngIf="recipientConnections.length">
                    <label>Send my quote request to the correct recipient at:</label>
                    <div class="row">
                        <div *ngFor="let connection of recipientConnections; let r = index" class="col-sm-6">
                            <div
                                id="recipient-connection-{{ r }}"
                                class="recipient-connection-container {{ connection.selected ? 'selected' : '' }}"
                                (click)="toggleRecipientConnection(connection)">
                                <div class="recipient-connection-checkbox">
                                    <i class="{{ connection.selected ? 'icon-ic-checkbox-s2 mango' : 'icon-ic-checkbox-s1' }}"></i>
                                </div>
                                <div class="recipient-connection-thumbnail" *ngIf="connection.logoUrl">
                                    <div class="img" [ngStyle]="{ 'background-image': 'url(' + connection.logoUrl + ')' }"></div>
                                </div>
                                <div class="recipient-connection-body" *ngIf="!connection.logoUrl">
                                    <span>{{ connection.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <div class="panel panel-white">
                        <div class="panel-heading border-light">
                            <h4 class="panel-title">Invitation Message</h4>
                            <ul class="panel-heading-tabs border-light">
                                <li>
                                    <div class="btn-group dropdown" dropdown [isDisabled]="quoteRequest.Status === 'Closed'">
                                        <button
                                            type="button"
                                            id="presets-dropdown-step-3"
                                            class="btn btn-default dropdown-toggle"
                                            dropdownToggle=""
                                            aria-haspopup="true"
                                            aria-expanded="false">
                                            <i class="ti-settings"></i> <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-right no-max-height" role="menu">
                                            <li>
                                                <a (click)="savePresetModal()"><i class="ti-save"></i> Save as preset</a>
                                            </li>
                                            <li>
                                                <a (click)="showManagePresetsModal()"><i class="ti-pencil"></i> Manage presets</a>
                                            </li>
                                            <li class="divider"></li>
                                            <ng-container *ngIf="!estimate?.IsReadOnly">
                                                <li disabled>
                                                    <span class="margin-left-20">Apply Preset</span>
                                                </li>
                                                <li *ngFor="let preset of getCurrentPresets()">
                                                    <a (click)="applyPreset(preset)"><i class="ti-list"></i> {{ preset.Description }}</a>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="panel-body">
                            <label class="text-info">
                                <span>Add a short message to go out with the invite email for this Quote Request</span>
                            </label>
                            <div class="form-group">
                                <div class="form-group">
                                    <bx-editor
                                        rows="4"
                                        class="bx-editor__height-200"
                                        [(data)]="quoteRequest.InvitationMessage"
                                        [config]="editorOptions"
                                        placeholder="Invitation message"></bx-editor>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end: WIZARD STEP 3 -->
            </div>
        </div>
    </div>
    <app-side-form-validation
        [formStatus]="formStatus"
        [serverErrorMessage]="serverErrorMessage"
        successMessage="Success"
        inProgressMessage="Saving">
    </app-side-form-validation>
    <div class="modal-footer">
        <button id="cancel" type="button" class="btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
        <button id="back" type="button" class="btn-bx-secondary-stroked ml-2" *ngIf="currentStep > 1" (click)="form.prev()">
            <span class="ti ti-angle-left" style="position: relative; top: 2px; right: 2px"></span> Back
        </button>
        <button
            type="button"
            id="save-draft"
            class="btn-bx-secondary ml-2"
            (click)="saveDraft()"
            [disabled]="!addForm.valid || !quoteRequest.QuoteRequestItems?.length || itemsWithZeroQty || quoteRequest.Status === 'Closed'">
            Save<span *ngIf="quoteRequest.Status === 'Draft'">&nbsp;Draft</span>
        </button>
        <button
            type="button"
            id="next"
            class="btn-bx-primary ml-2"
            *ngIf="currentStep < 3"
            (click)="form.next()"
            [disabled]="!addForm.valid || !quoteRequest.QuoteRequestItems?.length || itemsWithZeroQty">
            Next <span class="ti ti-angle-right" style="position: relative; top: 2px; left: 2px"></span>
        </button>
        <button
            type="submit"
            id="submit-rfq-{{ isBlankRFQ ? 'blank-job' : job ? 'job' : 'estimate' }}"
            class="btn-bx-primary ml-2"
            *ngIf="currentStep === 3 && (newRecipients.length || previousRecipients.length)"
            [disabled]="!addForm.valid || !quoteRequest.QuoteRequestItems?.length || quoteRequest.Status === 'Closed'">
            Send
        </button>
    </div>
</form>
